module.exports = __webpack_public_path__ + "img/one.386c4810.gif";